import React, { useState } from "react";
import MainLayout from "../../components/Layouts/Main/MainLayout.index";
import FW from "../../config/word.json";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import {
  MenuContainer,
  MenuCategory,
  MenuCategoryTitle,
  SubMenuList,
  SubMenuLink,
  CategoryIcon,
} from "./Menu.style";

export default function Menu() {
  const navigate = useNavigate();
  const [openCategory, setOpenCategory] = useState(null);

  useEffect(() => {
    const userId = sessionStorage.getItem("userId");
    if (!userId) {
      navigate("/");
      return;
    }
  }, [navigate]);

  const userFlg = sessionStorage.getItem("userFlg");
  const menuCategories = [
    ...(userFlg === "9"
      ? [
          {
            id: "approval",
            title: "承認フロー",
            icon: "📋",
            items: [
              { title: FW.F_W_HOME_ApprovalList, path: "/approvallist" },
              { title: FW.F_W_HOME_ApprovaledList, path: "/approvaledlist" },
              { title: FW.F_W_HOME_RejectList, path: "/rejectedlist" },
            ],
          },
          {
            id: "banner",
            title: "バナー管理",
            icon: "🖼️",
            items: [
              { title: "大バナー", path: "/bannerManage" },
              { title: "小バナー", path: "/smallBannerManage" },
            ],
          },
          {
            id: "analytics",
            title: "アナリティクス",
            icon: "📊",
            items: [{ title: "ユーザー分析", path: "/analytics" }],
          },
          {
            id: "sys",
            title: "システム",
            icon: "⚙️",
            items: [
              { title: "ユーザー変更履歴", path: "/admin/user/change-history" },
              { title: "データ移行", path: "/dataIko" },
            ],
          },
        ]
      : []),
    {
      id: "daikai",
      title: "大会管理",
      icon: "📅",
      items: [{ title: "大会管理", path: "/daikaiManage" }],
    },
  ];

  const toggleCategory = (categoryId) => {
    setOpenCategory(openCategory === categoryId ? null : categoryId);
  };

  return (
    <MainLayout>
      <MenuContainer>
        {menuCategories.map((category) => (
          <MenuCategory key={category.id}>
            <MenuCategoryTitle
              onClick={() => toggleCategory(category.id)}
              className={openCategory === category.id ? "open" : ""}
            >
              <CategoryIcon>{category.icon}</CategoryIcon>
              {category.title}
              <span className="toggle">
                {openCategory === category.id ? "−" : "+"}
              </span>
            </MenuCategoryTitle>
            {openCategory === category.id && (
              <SubMenuList>
                {category.items.map((item, index) => (
                  <SubMenuLink to={item.path} key={index}>
                    {item.title}
                  </SubMenuLink>
                ))}
              </SubMenuList>
            )}
          </MenuCategory>
        ))}
      </MenuContainer>
    </MainLayout>
  );
}
